import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WorkspacesComponent } from './components/workspaces/workspaces.component';
import { WorkspaceDetailsComponent } from './components/workspace-details/workspace-details.component';
import { ClauseVarianceAnalysisComponent } from './components/clause-variance-analysis/clause-variance-analysis.component';
import { referenceDocumentGuard } from './guards/reference-document.guard';
import { PermissionGuard } from 'src/app/core/guards/permission.guard';
import { PermissionResource } from 'src/app/core/constants/permissions.constants';

const routes: Routes = [
  {
    path: ':id',
    component: WorkspaceDetailsComponent,
  },
  {
    path: ':id/clause-variance-analysis',
    component: ClauseVarianceAnalysisComponent,
    canActivate: [PermissionGuard, referenceDocumentGuard],
    data: {
      permissionResources: [
        PermissionResource.VarianceAnalysis,
        PermissionResource.DocumentProcessing,
      ],
    },
  },
  {
    path: '',
    component: WorkspacesComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WorkspacesRoutingModule {}
